import type { WeaoStatus } from '../types'

/** Live update status from WEAO (working = current with the latest Roblox version). */
export function StatusBadge({ status }: { status: WeaoStatus | null | undefined }) {
  if (!status) return null
  return (
    <span className="weao" data-working={status.working}>
      <span className="weao__state" title="Update status (WEAO)">
        <i /> {status.working ? 'Working' : 'Patched'}
      </span>
    </span>
  )
}
